import moment from 'moment'
import { StatusView, SubscriptionStatus } from 'src/models/organizations.models'

// Returns the formatted end-of-paid-period date for the downgrade copy.
// The relevant date varies by status — ACTIVE carries nextBillingAt,
// NON_RENEWING carries cancelsAt, IN_TRIAL carries trialEnd. Returns
// null for the other statuses (FUTURE / PAUSED / CANCELLED) so callers
// fall back to the generic "end of your billing cycle" copy.
export function deriveBillingCycleEnd(
  state: StatusView | undefined,
): string | null {
  if (!state) return null
  switch (state.status) {
    case SubscriptionStatus.ACTIVE:
      return moment(state.nextBillingAt).format('MMMM D, YYYY')
    case SubscriptionStatus.NON_RENEWING:
      return moment(state.cancelsAt).format('MMMM D, YYYY')
    case SubscriptionStatus.IN_TRIAL:
      return moment(state.trialEnd).format('MMMM D, YYYY')
    default:
      return null
  }
}
